import {
  request2
} from './request.js'

// 获取分配权重
export function GetAssignWeightStatistic(obj) {
  return request2({
    url: '/api2/TZsbAdminFocuseApi/Statistics/GetAssignWeightStatistic',
    method: 'get',
    params: {
      dateMonth: obj.dateMonth,
      teamId: obj.teamId,
      workState: obj.workState,
      useCurrentWeightValueSort: obj.useCurrentWeightValueSort, //排序字段
      asc: obj.asc,
    }
  })
}
// 获取公海库报表
export function GetOpenSeaWarehouseReport(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/Report/GetOpenSeaWarehouseReport',
    method: 'get',
    params: {
      beginTime: obj.beginTime,
      endTime: obj.endTime,
    }
  })
}

// 获取分配接入报表
export function GetAssignAccessReport(obj) {
  let length = obj.sourceIds?.length || 0
  let Ids = ''
  for (let i = 0; i < length; i++) {
      if (i == length - 1) {
          Ids += `sourceIds=${obj.sourceIds[i]}`
      } else {
          Ids += `sourceIds=${obj.sourceIds[i]}&`
      }
  }
  return request2({
    url: `/api2/TZsbAdminStudentApi/Report/GetAssignAccessReport?${Ids}`,
    method: 'get',
    params: {
      beginTime: obj.beginTime,
      endTime: obj.endTime,
      endGrade: obj.endGrade || null,
      beginGrade: obj.beginGrade || null,
      state: obj.allocationState,
    }
  })
}

// 获取登记报名报表
export function GetUserSignUpReport(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/Report/GetUserSignUpReport',
    method: 'get',
    params: {
      type: obj.type,
      beginTime: obj.beginTime,
      endTime: obj.endTime,
      source: obj.source,
      payMoney: obj.payMoney,

    }
  })
}

// 获取信息完善报表
export function GetInformationCompletionReport(obj) {
  return request2({
    url: '/api2/TZsbAdminFocuseApi/Statistics/GetInformationCompletionStatistic',//'/api2/TZsbAdminStudentApi/Report/GetInformationCompletionReport',
    method: 'get',
    params: {
      beginTime: obj.beginTime,
      endTime: obj.endTime,
      payMoney: obj.payMoney,
      category: obj.category,
      beginGrade: obj.beginGrade || null,
      endGrade: obj.endGrade || null,
    }
  })
}

// 获取报表学员详情数据
export function GetAllStudentPage(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/GetAllStudentPage',
    method: 'post',
    data: {
      pageIndex: obj.PageIndex,
      pageSize: obj.PageSize,
      reportBeginTime: obj.reportBeginTime || null,
      reportEndTime: obj.reportEndTime || null,
      reportSource: obj.reportSource,
      reportPayMoney: obj.reportPayMoney,
      studentIds: obj.studentIds,
      type: obj.type,
      name: obj.name,
      telNumber: obj.telNumber,
      qqNumber: obj.qqNumber,
      grade: obj.grade,
      businessId: obj.businessId,
      handoverId: obj.handoverId,
      marketingId: obj.marketingId,
      operationId: obj.operationId,
      source: obj.source,
      reportType: obj.reportType,
    }
  })
}
//销售漏斗报表初始化接口
export function getBase() {
  return request2({
    url: '/api2/TZsbAdminStudentApi/Report/GetBaseInfo',
    method: 'get',

  })
}
//销售漏斗报表
export function GetSalesFunnelReport(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/Report/GetSalesFunnelReport',
    method: 'get',
    params: {
      Grade: obj.grade,
      CandidateCategory: obj.candidateCategory,
      Source: obj.source,
      GraduatedSchool: obj.graduatedSchool,
      GraduatedMajor: obj.graduatedMajor,
      BusinessId: obj.businessId,
      Remarks: obj.remarks,
      BeginTime: obj.beginTime,
      EndTime: obj.endTime,
      IsSignUp: obj.isSignUp,
      IsIntent: obj.isIntent,
      IsAddFriend: obj.isAddFriend,
    }
  })
}

// 转介绍溯源报表
export function GetTraceSourceList(params) {
  return request2({
    url: '/api2/TZsbAdminFocuseApi/Statistics/GetTraceSourceStatistic',//'/api2/TZsbAdminStudentApi/Report/GetInformationCompletionReport',
    method: 'get',
    params
  })
}

// 获取报表统计中学员信息--分配接入报表统计使用
export function GetReportStudentList(obj) {
  let length = obj.Source?.length || 0
  let Ids = ''
  for (let i = 0; i < length; i++) {
      if (i == length - 1) {
          Ids += `Source=${obj.Source[i]}`
      } else {
          Ids += `Source=${obj.Source[i]}&`
      }
  }
  return request2({
    url: `/api2/TZsbAdminStudentApi/Report/GetReportStudentList?${Ids}`,
    method: 'get',
    params: {
      Type: obj.Type,
      BeginTime: obj.BeginTime,
      EndTime: obj.EndTime,
      BusinessId: obj.BusinessId,
      Name: obj.Name,
      TelNumber: obj.TelNumber,
      QqNumber: obj.QqNumber,
      WechatId: obj.WechatId,
      Grade: obj.Grade,
      HandoverId: obj.HandoverId,
      MarketingId: obj.MarketingId,
      OperationId: obj.OperationId,
      PageIndex: obj.PageIndex,
      PageSize: obj.PageSize,
      FirstBusinessId: obj.FirstBusinessId,
      State: obj.State,
      AllocationState:obj.allocationState,
      StudentIntent:obj.StudentIntent,
    }
  })
}
//
// 获取周期报表学员详情数据
export function GetEnrollmentCycleReportStudentPage(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/GetEnrollmentCycleReportStudentPage',
    method: 'get',
    params: obj
  })
}
// 获取学员下拉框数据源,如来源渠道,意向度,入学年份,英语基础,预报课程
export function GetBusinessStudentsSelectListData() {
  return request2({
    url: '/api2/TZsbAdminStudentApi/BusinessStudentAdmin/GetBusinessStudentsSelectListData',
    method: 'get',
  })
}

// 获取权重分配报表分配学员详情列表
export function GetDistributionWeightStudentList(obj) {
  if(typeof(obj.Source) != 'object'){
    obj.Source = [obj.Source]
  }
  let length = obj.Source?.length || 0
  let Ids = ''
  for (let i = 0; i < length; i++) {
      if (i == length - 1) {
          Ids += `Source=${obj.Source[i]}`
      } else {
          Ids += `Source=${obj.Source[i]}&`
      }
  }
  return request2({
    url: `/api2/TZsbAdminStudentApi/Report/GetDistributionWeightStudentList?${Ids}`,
    method: 'get',
    params: {
      MonthDate: obj.MonthDate,
      BusinessId: obj.BusinessId,
      ActualBusinessId: obj.ActualBusinessId, // 实际业务老师ID筛选
      ClickType: obj.ClickType || 1,
      Name: obj.Name,
      TelNumber: obj.TelNumber,
      QqNumber: obj.QqNumber,
      Grade: obj.Grade,
      HandoverId: obj.HandoverId,
      MarketingId: obj.MarketingId,
      OperationId: obj.OperationId,
      PageIndex: obj.PageIndex,
      PageSize: obj.PageSize,
    }
  })
}
export function GetAchievementPageListWithTotal(obj) {
  return request2({
    url: `/api2/TZsbAdminOrderApi/Achievement/GetPageListWithTotal?pageIndex=${obj.pageIndex}&pageSize=${obj.pageSize}`,
    method: 'post',
    data: {
      AdminId: obj.AdminId || 0,
      StudentName: obj.StudentName,
      TelNumber: obj.TelNumber,
      AgreementState: obj.AgreementState,
      RefundState: obj.RefundState,
      IsCommon: obj.IsCommon,
      ProductTitle: obj.ProductTitle,
      StatrTime: obj.StatrTime,
      EndTime: obj.EndTime,
      orderType: obj.orderType,
      ProductIds: obj.ProductTuples,
      SourceIds: obj.SourceIds,
      RefundStates: obj.RefundStates,
      MarketingId: obj.MarketingId || 0,
      OperationId: obj.OperationId || 0,
    }
  })
}
